import { render, staticRenderFns } from "./coffee.vue?vue&type=template&id=15040916&scoped=true&"
import script from "./coffee.vue?vue&type=script&lang=js&"
export * from "./coffee.vue?vue&type=script&lang=js&"
import style0 from "./coffee.vue?vue&type=style&index=0&id=15040916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15040916",
  null
  
)

export default component.exports